export const compose = (...fns) =>
	fns.length === 0 ? () => {}
	: fns.length === 1 ? fns[0]
	: x => fns.reduce((result, fn) => fn(result), x);
